/**
 *
 * AccountLayout
 *
 */
import { useTheme } from '@material-ui/core';
import { BookitlabLoginLogo } from 'app/components/BookitlabLogo';
import { useIsMobile } from 'app/hooks/useIsMobile';
import * as React from 'react';
import styled from 'styled-components';
import { bookitColors } from 'styles/colors/bookitColors';
import { LoginScreenCompanyLogo } from '../FrontendLayout/components/LoginScreenCompanyLogo';
import { FooterContent } from './components/FooterContent';
import { GetMobileApp } from './components/GetMobileApp';
export interface AccountLayoutProps {
  children: React.ReactNode;
}
export const AccountRoot = styled('div')(({ theme }) => ({
  '&.accountRoot': {
    display: 'flex',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.25)',
    alignItems: 'flex-start',
    //justifyContent: 'center',
    flexDirection: 'row',
    width: '100%',
    height: '100dvh',
    //overflowY: 'hidden',
    [theme.breakpoints.down('sm')]: {
      //height: '100%',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      overflowY: 'auto',
    },
    background: bookitColors.base.white,
    '& .accountRightPanel': {
      display: 'flex',
      width: '420px',
      minWidth: '360px',
      padding: '64px',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexShrink: 0,
      alignSelf: 'stretch',
      background: `url(${
        process.env.PUBLIC_URL + '/images/login_right_bg.png'
      })`,
      transition: theme.transitions.create('width'),
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        order: 1,
      },
    },
    '& .accountContainer': {
      display: 'flex',
      paddingTop: '40px',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      flex: '1 0 0',
      alignSelf: 'stretch',
      background: bookitColors.base.white,
      transition: theme.transitions.create('width'),
      [theme.breakpoints.down('sm')]: {
        order: 0,
        //minHeight: '100%',
      },
      '& .accountMain': {
        height: 'auto',
        overflowY: 'auto',
        // paddingTop: '40px',
        [theme.breakpoints.down('sm')]: {
          height: '100%',
        },
      },
    },
  },
}));
export function AccountLayout(props: AccountLayoutProps) {
  const { children } = props;
  const { checkIsMobile } = useIsMobile();
  const isMobile = checkIsMobile();
  const theme = useTheme();
  return (
    <AccountRoot className={'accountRoot'} theme={theme}>
      <div className={'accountRightPanel'}>
        <BookitlabLoginLogo />
        {/* <div className={classes.spacer}></div> */}
        <GetMobileApp />
      </div>
      <div className={'accountContainer'}>
        <LoginScreenCompanyLogo
          isMobile={isMobile}
          height={isMobile ? 36 : 40}
        />
        <main className={'accountMain'}>{children}</main>
        <FooterContent isMobile={isMobile} />
      </div>
    </AccountRoot>
  );
}
